import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import { VixieesLeadsReport } from '../../modules/vixiees-leads';

export const VixieesLeadsPage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'vixieesLeads.title' })}
      </PageTitle>
      <div className="row gy-5 g-xl-8">
        <div className="card p-10">
          <VixieesLeadsReport />
        </div>
      </div>
    </>
  );
};
